// pet_it_frontend/src/api/queries.js

import API from './client';

/**
 * Obtiene un Pet por su ID.
 * @param {number|string} petId
 * @returns {Promise<Object>}
 */
export const fetchPetById = async (petId) => {
  const resp = await API.get(`/pets/${petId}/`);
  return resp.data;
};

/**
 * Obtiene un Profesional por su ID.
 * @param {number|string} profId
 * @returns {Promise<Object>}
 */
export const fetchProfessionalById = async (profId) => {
  const resp = await API.get(`/profesionales/${profId}/`);
  return resp.data;
};
